<template>
  <b-modal
    ref="modal-missing-items"
    modal-class="modal-missing-items"
    size="lg"
    body-class="px-0 pt-0 pb-0"
    hide-footer
    @hidden="hideModal"
    centered
    no-close-on-backdrop
  >
    <template #modal-header="{ close }" >
      <div class="header d-flex justify-content-between w-100">
        <div class="w-100 text-center">
          <h4 class="titleHeader pt-2 pl-5">未仕分けリスト</h4>
        </div>
        <div class="button-modal-header d-flex flex-row">
          <b-button
            size="sm"
            class="btn-close d-flex flex-row align-items-center"
            variant="link"
            @click="close()"
          >
            <i class="material-icons material-icons-outlined">close</i>
          </b-button>
        </div>
      </div>
    </template>
    <div class="d-flex modal-container" id="modal-container">
      <div class="d-flex modal-wrap-colum align-items-center justify-content-between w-100">
        <span class="top-left">{{totalRecords}}件</span>
        <div class="top-right d-flex align-items-center cursor-pointer" v-print="printModal()">
          <span class="icon material-icons material-icons-outlined">print</span>
          <span>リストを印刷</span>
        </div>
      </div>
      <div class="d-flex modal-bottom">
        <div class="batch-miss" v-if="parseInt(batchMissItems.length)">
          <table class="table-batch-miss table table-bordered">
            <tbody>
              <tr v-for="(batch, index) in batchMissItems" :key="index">
                <td>
                  <div class="body-top d-flex align-items-center justify-content-between">
                    <div class="col-6 body-top__left">
                      <span>{{batch.location}}</span>
                    </div>
                    <div class="col-6 body-top__right">
                      <span>バッチ：{{ batch.batchNo }}{{ isShowBatchDetailNo ? '-' + batch.batchDetailNo : '' }}</span>
                    </div>
                  </div>
                  <div class="body-bottom d-flex align-items-center justify-content-between">
                    <span class="quantity col-3">未仕分け数<br/><span>{{batch.missingItemsQuantity}}</span></span>
                    <div class="col-9">
                      <div class="d-flex flex-wrap">
                        <span>【{{label.productNo}}】{{batch.productNo}}</span>
                        <span v-if="batch.productName">【{{label.productName}}】{{batch.productName}}</span>
                      </div>
                      <div class="d-flex flex-wrap">
                        <span>【{{label.shopNo}}】{{batch.shopNo}}</span>
                        <span v-if="batch.shopName">【{{label.shopName}}】{{batch.shopName}}</span>
                      </div>
                      <div class="d-flex flex-wrap">
                        <span>【{{label.chuteNo}}】{{batch.chuteNo}}</span>
                      </div>
                      <div class="d-flex flex-wrap">
                        <span>【{{label.foreignLinkNo1}}】{{batch.foreignLinkNo1}}</span>
                        <span>【{{label.scanCode}}】{{batch.scanCode}}</span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="no-batch-miss" v-else>
          <span>未仕分けの商品はありません。</span>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import TaskService from '../../_services/task.service'
export default {
  data() {
    return {
      batchMissItems: [],
      totalRecords: 0,
      label: {},
      mstTableManagement: [],
      queryParam: {},
      headerOfPrintModal: '',
      dataOfModalPrint: {
        id: 'modal-container',
        popTitle: ' ',
        extraHead: ' '
      }
    }
  },
  model: {
    prop: 'isShowMissingModal',
    event: 'changeDisplayMode'
  },
  props: {
    isShowMissingModal: Boolean,
    isShowBatchDetailNo: Boolean
  },
  methods: {
    /**
     * ソートされていないデータを作成し、ソート解除 API を呼び出す
     */
    async generateMissingItems() {
      const response = await TaskService.getInstance().getMissingItems(this.queryParam)
      if (!response) {
        return
      }
      const batch = response.data
      this.batchMissItems = batch.missingItems
      this.totalRecords = batch.totalRecords
      this.mstTableManagement = batch.mstTableManagement
      const batchMissItemsLength = this.batchMissItems.length
      if (batchMissItemsLength) {
        this.setLabelNames()
      }
      this.generateDataModalPrint()
    },
    /**
     * 不足しているアイテムを表示するモーダル
     * @param {object} dataBatch trBatch のリクエスト
     */
    async showModal(dataBatch) {
      this.$emit('changeDisplayMode', true)
      this.queryParam = dataBatch
      await this.generateMissingItems()
      this.$refs['modal-missing-items'].show()
    },
    hideModal() {
      this.batchMissItems = []
      this.totalRecords = 0
      this.$emit('changeDisplayMode', false)
    },
    setLabelNames() {
      let keyItem = Object.keys(this.batchMissItems[0])
      this.mstTableManagement.forEach(label => {
        keyItem.forEach(item => {
          if (label.isItemNo.includes(item)) {
            this.label[label.isItemNo] = label.itemName
          }
        })
      })
    },
    /**
     * ユーザーが印刷ボタンをクリックしたときに、ソートされていないモーダル ヘッダーのデータを生成します。
     */
    generateDataModalPrint() {
      if (this.batchMissItems.length) {
        this.headerOfPrintModal = `<span class="total-count">${this.totalRecords}件</span>`
      } else {
        this.headerOfPrintModal = ' '
      }
      this.$set(this.dataOfModalPrint, 'extraHead', this.headerOfPrintModal)
    },
    /**
     * モードが印刷するときにソートされないモーダル ヘッダー データを設定します。
     */
    printModal() {
      return this.dataOfModalPrint
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .modal-dialog {
  max-width: 40vw !important;
  min-width: 600px !important;
  margin-top: 20px;
  margin-bottom: 20px;
  @include media-breakpoint-default() {
    margin-left: 140px !important;
    margin-right: 140px !important;
  }
}
/deep/ .modal-content {
  height: 652px;
}
/deep/ .modal-header {
  border-bottom: 0 none;
  .titleHeader {
    font-weight: 700;
    @include responsive-fs(20);
  }
}
/deep/ .modal-body {
  height: 100%;
  overflow: auto;
}
/deep/ .modal.modal-missing-items {
  overflow-y: auto;
  @include media-breakpoint-default() {
    overflow-x: auto !important;
  }
}
.modal-container {
  flex-direction: column;
  position: relative;
  .modal-wrap-colum {
    padding: 0px 24px 0px 24px;
    .top-left {
      @include responsive-fs(12);
    }
    .top-right {
      @include responsive-fs(12);
      padding-right: 8px;
      color: #4e66a6;
      .icon {
        @include responsive-fs(18);
        color: #4e66a6;
      }
      span {
        padding-left: 6px;
        @include responsive-fs(12);
      }
    }
  }
  .modal-bottom {
    flex-direction: column;
    .batch-miss {
      margin: 6.5px 24px 0px 24px;
      display: flex;
      flex-direction: column;
      .table-batch-miss {
        @include responsive-fs(12);
        tbody {
          td {
            padding: 0;
            border: 1px solid #D6D6D6;
            .body-top{
              margin: 16px 16px 0px 16px;
              padding-bottom: 4px;
              border-bottom: 1px solid #D6D6D6;
              font-weight: 700;
              &__left {
                text-align: left;
                padding: 0;
                word-break: break-all;
              }
              &__right {
                text-align: right;
                padding: 0;
                word-break: break-all;
              }
            }
            .body-bottom{
              padding: 4px 16px 16px 16px;
              word-break: break-all;
              .quantity {
                text-align: center;
                span {
                  @include responsive-fs(16);
                }
              }
            }
          }
        }
      }
    }
    .no-batch-miss {
      height: 525px;
      margin: 6.5px 24px 0px 24px;
      border: 1px solid #D6D6D6;
      position: relative;
      align-items: center;
      text-align: center;
      padding: 45px;

      span {
        width: 320px;
        height: 26px;
        font-weight: 400;
        line-height: 160%;
      }
    }
  }
}

.total-count {
  @include responsive-fs(14);
  padding-left: 24px;
}

@media print {
  @page {
    margin: 1.5cm 1cm 1cm 1cm;
    size: portrait;
  }
  tr, td {
    page-break-inside: avoid;
  }
  .top-right, .top-left {
    display: none !important;
  }
  .batch-miss {
    margin: 6.5px 24px 0px 24px;
    display: flex;
    flex-direction: column;
    height: 0px;
    .table-batch-miss {
      @include responsive-fs(14, true);
      tbody {
        td {
          padding: 0;
          border: 1px solid black !important;
          .body-top{
            margin: 16px 16px 0px 16px;
            padding-bottom: 4px;
            border-bottom: 1px solid black !important;
            font-weight: 700;
            &__left {
              text-align: left;
              padding: 0;
              word-break: break-all;
            }
            &__right {
              text-align: right;
              padding: 0;
              word-break: break-all;
            }
          }
          .body-bottom{
            padding: 4px 16px 16px 16px;
            word-break: break-all;
            .quantity {
              text-align: center;
              span {
                @include responsive-fs(16);
              }
            }
          }
        }
      }
    }
  }
  .no-batch-miss {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/MissingItemsModal.vue